"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextLabel2 = void 0;
var _createText = require("./createText");
const TextLabel2 = (0, _createText.createText)('label2');
exports.TextLabel2 = TextLabel2;